/**
 * @Injectable
 * All services for member model
 *
 */

import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../environments/environment';
import { Member } from '../models/member.model';
import { HttpService } from './http.service';


@Injectable()

export class MemberService {

  private apiModelUrl = environment.apiUrl + 'member/';

  constructor(
    private http: HttpService
  ) { }




  /**
	 * Get all the members with files and relations
   *
   * @return		{Promise}      of an array of documents
   */
  getAll(): Promise<Member[]> {
    return this.http.get(this.apiModelUrl + 'all')
               .toPromise()
               .then(response => response.json());
  }


  /**
	 * Get all the members with files and relations
   *
   * @return		{Promise}      of an array of documents
   */
  getAllForUserRole(roleId?: number, userId?: number): Promise<Member[]> {
      console.log(roleId);
      if (roleId == 1) {
          return this.http.get(this.apiModelUrl + 'all')
              .toPromise()
              .then(response => response.json());
      } else {
      return this.http.get(this.apiModelUrl + userId)
              .toPromise()
              .then(response => [response.json()]);
      }
      
  }


  /**
   * Get a member instance
   *
   * @param		  {Number}           the id of the document to retrieve
   * @return		{Promise}          of the found document
   */
  getOne(id: number): Promise<Member> {
    return this.http.get(this.apiModelUrl + id)
               .toPromise()
               .then(response => response.json());
  }

  /**
   * Save the given document and returns it
   *
   * @param		  {object}       an instance of the current document
   * @return		{Promise}      of the saved document
   */
  saveOne(member: any): Promise<Member> {
    if(member.id)
      if(member.password === '') delete member.password;
    return this.http.put(this.apiModelUrl + 'edit', member)
             .toPromise()
             .then(response => response.json());
  }

  delete(id: number): Promise<any> {
    return this.http.delete(this.apiModelUrl, id)
               .toPromise()
               .then(response => response);
  }

  getRoles(id: number): Promise<Member> {
      return this.http.get(this.apiModelUrl + id + '/roles')
          .toPromise()
          .then(response => response.json());
  }


  sendRejectionMail(referent_id, doc_title, vers, message): Promise<any> {
      return this.http.post(this.apiModelUrl + referent_id + '/mail', {doc_title, vers, message})
          .toPromise()
          .then(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/member.service.ts